import angular from 'angular'

import ApiInterceptorFactory from './api-interceptor.factory'

let module = angular.module('interceptors', [])
.factory('ApiInterceptor', ApiInterceptorFactory.factory)
.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/interceptors/index.js